// extracted by mini-css-extract-plugin
export var readonly = "_en-1";
export var star = "_en-0";